import ko from "knockout";
import register from "flow/knockout/register";

interface IValidationObservable extends KnockoutObservable<any> {
    hasError: KnockoutObservable<boolean>;
    validationMessage: KnockoutObservable<string>;
}

// http://knockoutjs.com/documentation/extenders.html
register.registerKnockoutExtension("lcrequired", function (target: IValidationObservable, overrideMessage: string) {
    //add some sub-observables to our observable
    target.hasError = ko.observable();
    target.validationMessage = ko.observable();

    //define a function to do validation
    function validate(newValue: any) {
        target.hasError(newValue ? false : true);
        target.validationMessage(newValue ? "" : overrideMessage || "This field is required");
    }

    //initial validation
    validate(target());

    //validate whenever the value changes
    target.subscribe(validate);

    //return the original observable
    return target;
});
